
const _authenticationResultTypes =
{
	UnknownUser: 1,
	BadPassword: 2,
	UserLockedOut: 3,
	Successful: 4,
	AnswerQuestion: 5,
	ChangePassword: 6,
	AnswerFailed: 7,
	ValidateEmail: 8,
	TwoFactorAuth: 9,
	SessionExpired: 10,
	AccountDisabled: 11,
	AcceptEula: 12,
	SessionInvalid: 13,
	UnknownDevice: 14
}

const _userGroups =
{
	Guest: 0,
	Dealers: 1,
	OEMs: 3,
	Administrators: 4
}

const _auctionStates =
{
	Grounded: 1,
	AwaitingInspection: 2,
	AwaitingPricing: 3,
	AwaitingRelease: 4,
	Released: 5,
	InSettlement: 6,
	Sold: 7,
	CompleteUnsold: 8,
	Expired: 9,
	Cancelled: 10,
	// New states added for AuctionTabs API (minimal additions)
	Hold: 11,
	Shipping: 12,
	PhysicalAuction: 13,
	Ungrounded: 14
}

/**
 * AuctionTabs Status ID Mapping
 * Maps tab/status concepts to AuctionState IDs.
 * Strategy: Use existing AuctionStates (1-10) where possible,
 * only introducing minimal new states (11-14).
 */
const _auctionTabStatuses =
{
	// Auction Tab - uses existing states
	Grounded: 1,
	AwaitingInspection: 2,
	AwaitingPricing: 3,
	AwaitingRelease: 4,  // aka "Awaiting Seller Release"
	Released: 5,         // aka "Live"
	Hold: 11,            // NEW: Manually paused
	
	// Bid Review Tab - uses existing InSettlement
	BidReview: 6,        // Same as InSettlement
	
	// Sold Tab - uses existing Sold
	Sold: 7,
	
	// Pending Tab - mix of existing and new
	CompleteUnsold: 8,   // aka "Unsold"
	Expired: 9,
	Cancelled: 10,
	Shipping: 12,        // NEW: Vehicle being shipped
	PhysicalAuction: 13, // NEW: At physical auction
	Ungrounded: 14       // NEW: Dealer ungrounded
}

/**
 * Auction Iteration Types (MBP → IT2 → IT3 → IT4 → OpenLane)
 */
const _auctionIterationTypes =
{
	MBP: 1,
	IT2: 2,
	IT3: 3,
	IT4: 4,
	OpenLane: 5
}

/**
 * Hold Reason Types for placing auctions on hold
 * BRD: Condition Review, Pricing Review, Dealer Request, OEM Request, Other
 */
const _auctionHoldReasonTypes =
{
	ConditionReview: 1,
	PricingReview: 2,
	DealerRequest: 3,
	OEMRequest: 4,
	Other: 99
}

/**
 * Counter Offer States
 */
const _counterOfferStates =
{
	Pending: 1,
	Accepted: 2,
	Declined: 3,
	Expired: 4
}

/**
 * Pending Status Values (string keys for API filter)
 */
const _pendingStatusValues =
{
	Unsold: 'Unsold',
	Shipping: 'Shipping',
	PhysicalAuction: 'PhysicalAuction',
	Cancelled: 'Cancelled',
	Ungrounded: 'Ungrounded'
}

const _auctionTierStates =
{
	New: 1,
	Pending: 2,
	Active: 3,
	Inactive: 4
}

const _auctionTemplateDefaultSourceTypes =
{
	AdHoc: 1,
	Oem: 2,
	Dealer: 3
}

const _auctionTierTypes =
{
	BiddingTier: 1,
	MBPTier: 2,
	OriginalDealerTier: 3
}

const _defaultTierDurationHours = 22

const _codeValidationResultTypes =
{
	Success: 1,
	InvalidKey: 2,
	ExpiredKey: 3,
	Resent: 4,
	PreviouslyUsed: 5,
	UnknownUser: 6
}

const _parentBidTypes =
{
	Bid: 1,
	Counter: 2
}

const _userRoles =
{
    CustomerUser: 1,
    DistrictManager: 3,
    ServicesUser: 5,
    BusinessAdministrator: 7,
    SalesManager: 10,
    LeaseRenewalManager: 11,
    GeneralManager: 12,
    BusinessManager: 13,
    SalesStaff: 14,
    RegionalManager: 15,
    NationalManager: 16,
    CustomerService: 17,
    CustomerServiceManager: 18,
    EOTCustomerService: 19,
    AccountingClerk: 20,
    AccountingManager: 21,
    RemarketingManager: 22,
    Remarketing: 23,
    AreaSalesManager: 24,
    AFIL: 25,
    OEMAdministrator: 26,
    DealerAdministrator: 27,
    AFILAdministrator: 28,
    DealerEmail: 29,
    AdminEmail: 30,
    GroundingManager: 31,
    GroundingStaff: 32,
    TcmManagerDealer: 33,
    TcmManagerOem: 34,
    TcmApproverOem: 35,
    TcmStaffDealer: 36,
    CbbAdjustmentManager: 37,
    SalesStaffDocuments: 38,
    ExternalUser: 39,
    AuctionBuyer: 40,
    AuctionViewer: 41,
    AuctionHybrid: 42
}

const _storageTypes =
{
    InspectionPictures: 1,
    ConfirmationOfSales: 2
}

const Enumeration =
{
	AuthenticationResultTypes: _authenticationResultTypes,
	UserGroups: _userGroups,
	AuctionStates: _auctionStates,
	AuctionTabStatuses: _auctionTabStatuses,
	AuctionIterationTypes: _auctionIterationTypes,
	AuctionHoldReasonTypes: _auctionHoldReasonTypes,
	CounterOfferStates: _counterOfferStates,
	PendingStatusValues: _pendingStatusValues,
	AuctionTierStates: _auctionTierStates,
	AuctionTemplateDefaultSourceTypes: _auctionTemplateDefaultSourceTypes,
	AuctionTierTypes: _auctionTierTypes,
	DefaultTierDurationHours: _defaultTierDurationHours,
	CodeValidationResultTypes: _codeValidationResultTypes,
	ParentBidTypes: _parentBidTypes,
    UserRoles: _userRoles,
    StorageTypes: _storageTypes
}

export default Enumeration
